function _templateObject2() {
  var data = _taggedTemplateLiteral(["display: none"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["display: none"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/* eslint-disable @typescript-eslint/no-explicit-any */
import { css } from 'styled-components';
import { getBreakpoints } from "../selectors";
export var mediaSmDown = function mediaSmDown() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return function (_ref) {
    var theme = _ref.theme;

    var _getBreakpoints = getBreakpoints(theme),
        sm = _getBreakpoints.sm;

    return css(["@media (max-width:", "px){", "}"], sm - 1, css.apply(void 0, args));
  };
};
export var mediaSmUp = function mediaSmUp() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  return function (_ref2) {
    var theme = _ref2.theme;

    var _getBreakpoints2 = getBreakpoints(theme),
        sm = _getBreakpoints2.sm;

    return css(["@media (min-width:", "px){", "}"], sm, css.apply(void 0, args));
  };
};
export var mediaMdDown = function mediaMdDown() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  return function (_ref3) {
    var theme = _ref3.theme;

    var _getBreakpoints3 = getBreakpoints(theme),
        md = _getBreakpoints3.md;

    return css(["@media (max-width:", "px){", "}"], md - 1, css.apply(void 0, args));
  };
};
export var mediaMdUp = function mediaMdUp() {
  for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    args[_key4] = arguments[_key4];
  }

  return function (_ref4) {
    var theme = _ref4.theme;

    var _getBreakpoints4 = getBreakpoints(theme),
        md = _getBreakpoints4.md;

    return css(["@media (min-width:", "px){", "}"], md, css.apply(void 0, args));
  };
};
export var hideBeforeSm = mediaSmDown(_templateObject());
export var hideAfterSm = mediaSmUp(_templateObject2());